import styled from 'styled-components/macro';

export const List = styled.ul`
  display: flex;
  column-gap: 1rem;
  align-items: center;
  justify-content: center;
`;
export const ListItem = styled.li``;
